import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { PortalService } from "services/portal";

export function PortalVerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | success | autologin | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Token no proporcionado");
      return;
    }

    PortalService.verifyEmail({ token })
      .then((res) => {
        setMessage(res.message || "Email verificado exitosamente");
        if (res.token) {
          // Auto-login: persistimos sesión y vamos al dashboard.
          try {
            localStorage.setItem(
              "userdata:portal",
              JSON.stringify({ token: res.token, member: res.member })
            );
          } catch {}
          setStatus("autologin");
          setTimeout(() => navigate("/portal/dashboard", { replace: true }), 1200);
        } else {
          setStatus("success");
        }
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err?.response?.data?.error || "Error al verificar el correo");
      });
  }, [token, navigate]);

  const containerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    background: "#f8fafc",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  };

  const cardStyle = {
    background: "#fff",
    borderRadius: "12px",
    padding: "48px",
    maxWidth: "440px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
  };

  const iconStyle = {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 24px",
    fontSize: "28px",
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        {status === "loading" && (
          <>
            <div
              style={{
                ...iconStyle,
                background: "#eff6ff",
                color: "#2563eb",
              }}
            >
              ...
            </div>
            <h2 style={{ color: "#1e293b", fontSize: "1.25rem", marginBottom: "8px" }}>
              Verificando tu correo
            </h2>
            <p style={{ color: "#64748b", fontSize: "0.9rem" }}>
              Espera un momento...
            </p>
          </>
        )}

        {status === "autologin" && (
          <>
            <div style={{ ...iconStyle, background: "#ecfdf5", color: "#059669" }}>&#10003;</div>
            <h2 style={{ color: "#1e293b", fontSize: "1.25rem", marginBottom: "8px" }}>
              ¡Bienvenido!
            </h2>
            <p style={{ color: "#64748b", fontSize: "0.9rem", marginBottom: "24px" }}>
              Te llevamos al panel...
            </p>
          </>
        )}

        {status === "success" && (
          <>
            <div
              style={{
                ...iconStyle,
                background: "#ecfdf5",
                color: "#059669",
              }}
            >
              &#10003;
            </div>
            <h2 style={{ color: "#1e293b", fontSize: "1.25rem", marginBottom: "8px" }}>
              Correo verificado
            </h2>
            <p style={{ color: "#64748b", fontSize: "0.9rem", marginBottom: "24px" }}>
              {message}
            </p>
            <Link
              to="/portal/login"
              style={{
                display: "inline-block",
                padding: "0.75rem 2rem",
                background: "linear-gradient(135deg, #0f172a 0%, #334155 100%)",
                color: "#fff",
                borderRadius: "0.625rem",
                textDecoration: "none",
                fontWeight: 600,
                fontSize: "0.9rem",
              }}
            >
              Ir a iniciar sesion
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <div
              style={{
                ...iconStyle,
                background: "#fef2f2",
                color: "#dc2626",
              }}
            >
              &#10007;
            </div>
            <h2 style={{ color: "#1e293b", fontSize: "1.25rem", marginBottom: "8px" }}>
              Error de verificacion
            </h2>
            <p style={{ color: "#64748b", fontSize: "0.9rem", marginBottom: "24px" }}>
              {message}
            </p>
            <Link
              to="/portal/login"
              style={{
                display: "inline-block",
                padding: "0.75rem 2rem",
                background: "#e2e8f0",
                color: "#334155",
                borderRadius: "0.625rem",
                textDecoration: "none",
                fontWeight: 600,
                fontSize: "0.9rem",
              }}
            >
              Volver al login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
